import { PostElement } from "src/api/client-api/post/postSchema";
import { CommentData } from "../CommentDialog/CommentDialog";
import { usePropertyContext } from "../context/usePropertyContext";
import { FoodsTags, FoodsIconButton, FoodsIcon, FoodsTooltip } from "@foodpilot/foods";
import { Stack, Box, useTheme } from "@mui/material";
import { MenuItemType } from "src/components/ActionsPopover/ActionsPopover.types";
import { useTranslation } from "react-i18next";

type Props = {
    element: PostElement | undefined;
};
export const UploadFileAndComment = (props: Props) => {
    const { setMenuItems, setRowMenuAnchor, attachmentState, commentState, allowComments } = usePropertyContext();
    const { t } = useTranslation();
    const theme = useTheme();

    const { element } = props;
    const commentsArray = element?.ssqPostComments ?? [];
    const ssqPostElementId = element?.id ?? null;

    const commentData: CommentData | null =
        Array.isArray(commentsArray) && commentsArray.length > 0 ?
            {
                comment: commentsArray[0].comment,
                commentId: commentsArray[0].id,
                updatedAt: commentsArray[0].updatedAt,
                userName:
                    `${commentsArray[0].createdBy.firstname ?? ""} ${commentsArray[0].createdBy.lastname ?? ""}`.trim(),
            }
        :   null;

    const fileData = element?.ssqPostAttachments ?? [];

    const hasComment = commentsArray.length > 0;
    if (allowComments === false) {
        return null;
    }

    return (
        <Stack flexDirection={"row"} gap={theme.spacing(1)}>
            {hasComment && (
                <Box>
                    <FoodsTags
                        // label={t("property.one_note")}
                        label={`${commentsArray.length}`}
                        variant="tags-white"
                        startIcon="tagComment"
                        onClick={() => {
                            if (element?.id) commentState.openCommentDialog(element?.id, commentData);
                        }}
                    />
                </Box>
            )}

            {!!fileData.length && ssqPostElementId && (
                <Box>
                    <FoodsTags
                        // label={t("property.one_file", "1 file")}
                        label={`${fileData.length}`}
                        variant="tags-white"
                        startIcon="attachment"
                        onClick={() => attachmentState.openAttachmentDialog(ssqPostElementId, fileData)}
                    />
                </Box>
            )}
            <FoodsTooltip
                title={
                    ssqPostElementId ? "" : (
                        t("property.attachment.answer_first", "Answer the question before adding files or a note")
                    )
                }
                placement="top"
            >
                <Box component="span" sx={{ display: "inline-flex" }}>
                    <FoodsIconButton
                        size={"xs"}
                        icon="plus"
                        withBackground={true}
                        buttonProps={{
                            "aria-label": t("property.attachment.add_evidence", "Add files or a note"),
                            disabled: !ssqPostElementId,
                            onClick: (e) => {
                                if (!ssqPostElementId) return;

                                const menuItems: MenuItemType[] = [];

                                const fileMenuItem: MenuItemType = {
                                    icon: <FoodsIcon icon="addFile" size={2} />,
                                    label: t("property.attachment.add_file", "Add files"),
                                    onClick: () => {
                                        attachmentState.openAttachmentDialog(ssqPostElementId, fileData);
                                        setRowMenuAnchor(null);
                                    },
                                };
                                menuItems.push(fileMenuItem);

                                const commentMenuItem: MenuItemType = {
                                    icon: <FoodsIcon icon="edit" size={2} />,
                                    label: t("property.attachment.edit_note", "Edit a note"),
                                    onClick: () => {
                                        commentState.openCommentDialog(ssqPostElementId, commentData);
                                        setRowMenuAnchor(null);
                                    },
                                    isDisabled: !!commentData,
                                };

                                if (hasComment === false) {
                                    menuItems.push(commentMenuItem);
                                }

                                setMenuItems(menuItems);
                                setRowMenuAnchor(e.currentTarget);
                            },
                        }}
                    />
                </Box>
            </FoodsTooltip>
        </Stack>
    );
};
